<template>
  <div>
    <vue-headful title="Match voorkeuren" />
    <Header page_title="Match voorkeuren" />
    <div class="heading border-bottom">
      <div class="max-600">
        <div class="d-flex align-items-center px-4 mx-2">
          <div class="flex-grow-1">
            <h2 class="d-inline-block position-relative mb-0">
              Match voorkeuren
            </h2>
          </div>
          <div class="icon position-relative">
            <svg viewBox="0 0 73 73" xmlns="http://www.w3.org/2000/svg">
              <g fill="none" fill-rule="evenodd">
                <g fill="#DCDBDB" fill-rule="nonzero">
                  <path
                    d="m36.5 0c-20.11 0-36.5 16.39-36.5 36.5s16.39 36.5 36.5 36.5 36.5-16.39 36.5-36.5-16.39-36.5-36.5-36.5zm0 66.49c-16.506 0-29.99-13.484-29.99-29.99s13.484-29.99 29.99-29.99 29.99 13.484 29.99 29.99-13.484 29.99-29.99 29.99z"
                  />
                  <path
                    d="m26.648 24c3.6013 0 6.6485 2.4966 6.6485 7.8659 0 5.5062-3.0472 7.8659-6.6485 7.8659-3.6359 0-6.6485-2.3598-6.6485-7.8659 0-5.3694 3.0126-7.8659 6.6485-7.8659zm18.976 0.1368-14.994 24.761h-3.4627l14.994-24.761h3.4627zm-18.941 2.6334c-2.1469 0-3.1511 1.7442-3.1511 5.0274 0 3.4542 1.0042 5.1642 3.1511 5.1642 2.0776 0 3.1165-1.71 3.1165-5.0958 0-3.3516-1.0388-5.0958-3.1165-5.0958zm19.668 6.4295c3.6013 0 6.6485 2.4966 6.6485 7.9001 0 5.5062-3.0472 7.9001-6.6485 7.9001-3.6359 0-6.6485-2.394-6.6485-7.9001 0-5.4036 3.0126-7.9001 6.6485-7.9001zm0 2.8386c-2.1469 0-3.1511 1.6758-3.1511 5.0274 0 3.4542 1.0042 5.0958 3.1511 5.0958 2.0776 0 3.1165-1.6416 3.1165-5.0616 0-3.3858-1.0388-5.0616-3.1165-5.0616z"
                  />
                </g>
              </g>
            </svg>
          </div>
        </div>
      </div>
    </div>
    <section class="block border-bottom">
      <div class="max-600">
        <div class="px-4 mx-2 py-4">
          <NotificationContainer />
          <h3 class="clearfix mb-0">
            <span class="float-left">Jouw zoekgebied:</span>
          </h3>
          <small>Afstand in km vanaf jouw adres.</small>
          <VueSlideBar v-model="search_distance" :min="0" :max="100">
            <template slot="tooltip">
              <div class="range-tooptip"></div>
              <div class="tooptip value" v-html="search_distance"></div>
            </template>
          </VueSlideBar>
          <div class="range-values clearfix">
            <div class="float-left">
              <small>0</small>
            </div>
            <div class="float-right">
              <small>100</small>
            </div>
          </div>
          <router-link
            :to="{ name: 'location' }"
            class="btn btn-gray btn-block btn-w-icon"
          >
            Vul hier je adresgegevens in
            <i class="material-icons">location_searching</i>
          </router-link>
        </div>
      </div>
    </section>
    <section class="block border-bottom">
      <div class="max-600">
        <div class="px-4 mx-2 py-4">
          <h3 class="mb-0">Jouw beschikbaarheid:</h3>
          <router-link
            :to="{ name: 'availability' }"
            class="btn btn-gray btn-block btn-w-icon"
          >
            {{ user.total_dates }} dagen (wijzig)
            <i class="material-icons-outlined">calendar_today</i>
          </router-link>
        </div>
      </div>
    </section>
    <section v-if="this.branch == 1" class="block border-bottom">
      <div class="max-600">
        <div class="px-4 mx-2 py-3">
          <button
            type="button"
            data-toggle="collapse"
            data-target="#collapseEducation"
            aria-expanded="false"
            aria-controls="collapseEducation"
          >
            <span class="float-left">Informatie over opleidingen:</span>
            <span class="float-right down">
              <i class="material-icons">keyboard_arrow_down</i>
            </span>
            <span class="float-right right">
              <i class="material-icons">keyboard_arrow_right</i>
            </span>
          </button>
          <div class="collapse" id="collapseEducation">
            <div
              class="pt-3 my-5 educdiv"
              v-if="education ? Object.keys(education).length > 0 : false"
            >
              <ul class="list-unstyled my-1">
                <li v-for="(arr, key1) in guide" v-bind:key="key1">
                  <div v-for="(obj, key2) in arr" v-bind:key="key2">
                    <div v-if="education[obj.url]" class="clearfix text-14">
                      <label class="float-left educ">{{
                        obj.label ? obj.label + ":" : "&nbsp;"
                      }}</label>
                      <div class="float-left val educ">
                        <strong class="answer">{{
                          translate(education[obj.url])
                        }}</strong>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <router-link
              :to="{ name: 'applicant-step_3', params: { action: 'save' } }"
              class="btn btn-gray btn-block"
              >Wijzig</router-link
            >
          </div>
        </div>
      </div>
    </section>
    <section v-if="this.branch == 1" class="block border-bottom">
      <div class="max-600">
        <div class="px-4 mx-2 py-3">
          <button
            type="button"
            data-toggle="collapse"
            data-target="#collapseExperience"
            aria-expanded="false"
            aria-controls="collapseExperience"
          >
            <!-- <span class="float-left">Trede binnen het onderwijs:</span> -->
            <span class="float-left">Ervaring binnen onderwijs:</span>
            <span class="float-right down">
              <i class="material-icons">keyboard_arrow_down</i>
            </span>
            <span class="float-right right">
              <i class="material-icons">keyboard_arrow_right</i>
            </span>
          </button>
          <div class="collapse" id="collapseExperience">
            <div v-if="experience">
              <ul
                v-if="Object.keys(experience).length > 0"
                class="list-unstyled"
              >
                <li class="clearfix">
                  <label class="float-left">Aantal jaar:</label>
                  <div class="float-left val">
                    <strong>
                      {{
                        experience.years_experience
                          ? experience.years_experience
                          : "-"
                      }}
                    </strong>
                  </div>
                </li>
                <li class="clearfix">
                  <label class="float-left">Functie(s):</label>
                  <div class="float-left val">
                    <strong>
                      {{ !experience.position ? "-" : "" }}
                      <span
                        v-for="(item, i) in experience.position"
                        v-bind:key="i"
                        class="d-block"
                        >{{ item }}</span
                      >
                    </strong>
                  </div>
                </li>
                <li class="clearfix">
                  <label class="float-left">Doelgroepen:</label>
                  <div class="float-left val">
                    <strong>
                      {{ !experience.audience ? "-" : "" }}
                      <span
                        v-for="(item, i) in experience.audience"
                        v-bind:key="i"
                        class="d-block"
                        >{{ item }}</span
                      >
                    </strong>
                  </div>
                </li>
                <li class="clearfix">
                  <label class="float-left">Type:</label>
                  <div class="float-left val">
                    <strong>
                      {{ !experience.education_experience ? "-" : "" }}
                      <span
                        v-for="(item, i) in experience.education_experience"
                        v-bind:key="i"
                        class="d-block"
                        >{{ item }}</span
                      >
                    </strong>
                  </div>
                </li>
                <li class="clearfix">
                  <label class="float-left">Denominatie:</label>
                  <div class="float-left val">
                    <strong>
                      {{ !experience.denomination ? "-" : "" }}
                      <span
                        v-for="(item, i) in experience.denomination"
                        v-bind:key="i"
                        class="d-block"
                        >{{ item }}</span
                      >
                    </strong>
                  </div>
                </li>
                <li class="clearfix" v-if="experience.open_field">
                  <label class="float-left">Welke daginvulling kun jij geven wanneer je als invaller voor de klas staat:</label>
                  <div class="float-left val">
                    <strong>
                      {{
                        experience.open_field
                          ? experience.open_field
                          : "-"
                      }}
                    </strong>
                  </div>
                </li>
              </ul>
            </div>
            <router-link
              :to="{ name: 'applicant-step_2', params: { action: 'save' } }"
              class="btn btn-gray btn-block"
              >Wijzig</router-link
            >
          </div>
        </div>
      </div>
    </section>
    <section v-if="this.branch == 2" class="block border-bottom">
      <div class="max-600">
        <div class="px-4 mx-2 py-3">
          <button
            type="button"
            data-toggle="collapse"
            data-target="#collapseExperience"
            aria-expanded="false"
            aria-controls="collapseExperience"
          >
            <span class="float-left">Ervaring binnen de kinderopvang:</span>
            <span class="float-right down">
              <i class="material-icons">keyboard_arrow_down</i>
            </span>
            <span class="float-right right">
              <i class="material-icons">keyboard_arrow_right</i>
            </span>
          </button>
          <div class="collapse" id="collapseExperience">
            <div v-if="experience">
              <ul
                v-if="Object.keys(experience).length > 0"
                class="list-unstyled"
              >
                <li class="clearfix">
                  <label class="float-left">Aantal jaar:</label>
                  <div class="float-left val">
                    <strong>
                      {{
                        experience.years_experience
                          ? experience.years_experience
                          : "-"
                      }}
                    </strong>
                  </div>
                </li>
                <li class="clearfix">
                  <label class="float-left">Functie(s):</label>
                  <div class="float-left val">
                    <strong>
                      {{ !experience.position ? "-" : "" }}
                      <span
                        v-for="(item, i) in experience.position"
                        v-bind:key="i"
                        class="d-block"
                      >
                        {{ item }}
                      </span>
                    </strong>
                  </div>
                </li>
                <li class="clearfix">
                  <label class="float-left">Ervaring met leeftijden:</label>
                  <div class="float-left val">
                    <strong>
                      {{ !experience.age_category ? "-" : "" }}
                      <span
                        v-for="(item, i) in experience.age_category"
                        v-bind:key="i"
                        class="d-block"
                      >
                        {{ item }}
                      </span>
                    </strong>
                  </div>
                </li>
                <li class="clearfix">
                  <label class="float-left">Bevoegd voor:</label>
                  <div class="float-left val">
                    <strong>
                      <span>{{ workfield }}</span
                      >
                    </strong>
                  </div>
                </li>
                <li class="clearfix" v-if="experience.open_field">
                  <label class="float-left">Welke daginvulling/activiteiten kan jij bieden als je invalt:</label>
                  <div class="float-left val">
                    <strong>
                      {{
                        experience.open_field
                            ? experience.open_field
                            : "-"
                      }}
                    </strong>
                  </div>
                </li>
              </ul>
            </div>
            <router-link
              :to="{ name: 'experience-childcare' }"
              class="btn btn-gray btn-block"
            >
              Wijzig
            </router-link>
          </div>
        </div>
      </div>
    </section>
    <section class="block border-bottom">
      <div class="max-600">
        <div class="px-4 mx-2 py-3">
          <button
            type="button"
            data-toggle="collapse"
            data-target="#collapseSalary"
            aria-expanded="false"
            aria-controls="collapseSalary"
          >
            <span class="float-left">Verdiensten:</span>
            <span class="float-right down">
              <i class="material-icons">keyboard_arrow_down</i>
            </span>
            <span class="float-right right">
              <i class="material-icons">keyboard_arrow_right</i>
            </span>
          </button>
          <div class="collapse" id="collapseSalary">
            <ul
              class="list-unstyled"
              v-if="
               user.customer_type === 0 && salary_tier && user.years_experience && user.salary_per_hour
              "
            >
              <li class="clearfix">
                <label class="float-left">Schaal:</label>
                <div class="float-left val">
                  <strong>{{ salary_tier ? salary_tier : "-" }}</strong>
                </div>
              </li>
              <li class="clearfix">
                <label class="float-left">Trede:</label>
                <div class="float-left val">
                  <strong>
                    {{
                      user.years_experience
                        ? user.years_experience
                        : "-"
                    }}
                  </strong>
                </div>
              </li>
              <li class="clearfix">
                <label class="float-left">EUR / uur:</label>
                <div class="float-left val">
                  <strong>{{
                    user.salary_per_hour ? user.salary_per_hour : "-"
                  }}</strong>
                </div>
              </li>
            </ul>

            <ul
                    class="list-unstyled"
                    v-if="
                 user.customer_type === 1
              "
            >
              <li class="clearfix" v-if="user.branche == 1">
                <label class="float-left">Schaal:</label>
                <div class="float-left val">
                  <strong>{{ salary_tier ? salary_tier : "-" }}</strong>
                </div>
              </li>
              <li class="clearfix">
                <label class="float-left">Trede:</label>
                <div class="float-left val">
                  <strong>
                    {{
                    user.years_experience
                        ? user.years_experience
                        : "-"
                    }}
                  </strong>
                </div>
              </li>
              <li class="clearfix">
                <label class="float-left">EUR / uur:</label>
                <div class="float-left val">
                  <strong>{{ user.salary_per_hour ? user.salary_per_hour : "-" }}</strong>
                </div>
              </li>

              <li class="clearfix">
                <label class="float-left">KVK nummer:</label>
                <div class="float-left val">
                  <strong>{{ user.kvk ? user.kvk : "-" }}</strong>
                </div>
              </li>

              <li class="clearfix">
                <label class="float-left">BTW nummer:</label>
                <div class="float-left val">
                  <strong>{{ user.btw ? user.btw : "-" }}</strong>
                </div>
              </li>

              <li class="clearfix">
                <label class="float-left">Tenaamstelling onderneming:</label>
                <div class="float-left val">
                  <strong>{{ user.company_name ? user.company_name : "-" }}</strong>
                </div>
              </li>
            </ul>
            <router-link
              :to="{ name: 'salary-details' }"
              class="btn btn-gray btn-block"
              >Wijzig</router-link
            >
          </div>
        </div>
      </div>
    </section>
    <div class="px-4 mx-2 py-4">
      <router-link
        :to="{ name: 'applicant-dashboard' }"
        title="Naar mijn Dashboard"
        class="btn btn-warning btn-block"
        v-ripple="'rgba(255, 255, 255, 0.35)'"
      >
        <strong>Naar mijn Dashboard</strong>
      </router-link>
    </div>
  </div>
</template>

<script>
import VueSlideBar from "vue-slide-bar";
export default {
  components: {
    VueSlideBar
  },
  data: function() {
    return {
      branch: 0,
      user: "",
      experience: null,
      education: null,
      salaries: "",
      salary_tier: "",
      workfield: null,
      // count: {
      //   dates: 0
      // },
      // form: {
      //   },
      search_distance: 0,
      guide: {
        1: [
          { url: 1, label: "Opgeleid als leerkracht" },
          { url: "1_YES", label: null },
          { url: "1_STUDYING_A", label: null },
          { url: "1_STUDYING_B", label: null }
        ],
        2: [
          { url: 2, label: "Onderwijsassistent" },
          { url: "2_YES", label: null },
          { url: "2_YES_EXTRA", label: "Zelfstandig voor de klas" },
          { url: "2_STUDYING_A", label: null },
          { url: "2_STUDYING_B", label: null }
        ],
        3: [
          { url: 3, label: "1e of 2e graad" },
          { url: "3_YES", label: null },
          { url: "3_STUDYING_A", label: null },
          { url: "3_STUDYING_B", label: null }
        ],
        4: [
          { url: 4, label: "Master EN (SEN)" },
          { url: "4_YES", label: null },
          { url: "4_STUDYING_A", label: null },
          { url: "4_STUDYING_B", label: null }
        ],
        5: [
          { url: 5, label: "Buitenlandse lesbevoegdheid" },
          { url: "5_YES", label: null }
        ]
      },
      saveOnUpdate: false
    };
  },
  async created() {},
  async mounted() {
    await this.fetchData();
  },
  watch: {
    $route: "fetchData",
    search_distance: {
      immediate: false,
      handler: function() {
        if (this.saveOnUpdate) {
          // console.log("changed");
          this.saveDistance();
        }
      }
    }
  },
  methods: {
    async fetchData() {
      this.branch = localStorage.getItem("branch");
      this.$store.state.loading = true;
      this.user = JSON.parse(localStorage.getItem("user"));
      this.salaries = await this.getAPIList("salaries/" + this.branch);
      // const dates = JSON.parse(this.user.search_availability);
      // if (dates) {
      //   this.count = Object.assign({}, this.count, {
      //     dates: dates.length
      //   });
      // }
      await this.autoFillForm();
      // any change on form should be saved
      this.saveOnUpdate = true;
      // await this.getExperience();

      // await this.getEducation();
      // await this.getQuestions();

      // await this.sortQs();
      this.$store.state.loading = false;
    },
    async autoFillForm() {
      return new Promise(resolve => {
        // update the form obj from user
        // for (var obj in this.form) {
        //   if (this.user[obj]) {
        //     this.form[obj] = this.user[obj];
        //   }
        // }
        this.search_distance = this.user.search_distance;

        if (this.user.experience) {
          this.experience = JSON.parse(this.user.experience);
        }
        if (this.user.education) {
          this.education = JSON.parse(this.user.education);
        }
        if (this.user.workfield != null) {
          this.workfield = this.getWorkfieldByNumber(this.user.workfield);
        }

        // salary tier
        var result = this.salaries.filter(obj => {
          return obj.id === this.user.salary_id;
        });
        if (result[0]) {
          this.salary_tier = result[0].name;
        }
        resolve();
      });
    },
    async updateDistance() {
      return new Promise((resolve, reject) => {
        var user_token = JSON.parse(localStorage.getItem("user-token"));
        var url = this.$apiURI + "/location";
        let formData = new FormData();
        // for (var obj in this.form) {
        //   formData.append(obj, this.form[obj]);
        // }
        formData.append("search_distance", this.search_distance);
        this.$http
          .post(url, formData, {
            headers: {
              Authorization: "Bearer " + user_token,
              Accept: "application/json"
            }
          })
          .then(() => {
            // console.log(success);
            const notification = {
              type: "success",
              message: "Je hebt je gegevens succesvol aangepast. "
            };
            this.$store.dispatch("notification/replace", notification, {
              root: true
            });
            resolve();
          })
          .catch(() => {
            // console.log(error);
            const notification = {
              type: "danger",
              message: "Er is een fout opgetreden.",
                error: true
            };
            this.$store.dispatch("notification/replace", notification, {
              root: true
            });
            reject();
          });
      });
    },
    async saveDistance() {
      await this.updateDistance();
      // continue only if resolve()
      await this.updateLocalUser();
      this.user = JSON.parse(localStorage.getItem("user"));
    },
    async getExperience() {
      return new Promise((resolve, reject) => {
        var url = "applicant/answers/experience";
        let user_token = JSON.parse(localStorage.getItem("user-token"));
        this.$http
          .get(this.$apiURI + "/" + url, {
            headers: {
              Authorization: "Bearer " + user_token,
              Accept: "application/json"
            }
          })
          .then(resp => {
            if (resp.data) {
              this.experience = resp.data;
              resolve();
            } else {
              resolve();
            }
          })
          .catch(() => {
            // console.log(error);
            const notification = {
              type: "danger",
              message: "Er is een fout opgetreden.",
                error: true
            };
            this.$store.dispatch("notification/replace", notification, {
              root: true
            });
            reject();
          });
      });
    },
    async getEducation() {
      return new Promise((resolve, reject) => {
        var url = "applicant/answers/education";
        let user_token = JSON.parse(localStorage.getItem("user-token"));
        this.$http
          .get(this.$apiURI + "/" + url, {
            headers: {
              Authorization: "Bearer " + user_token,
              Accept: "application/json"
            }
          })
          .then(resp => {
            if (resp.data) {
              var list = resp.data;
              if (list.constructor === Object) {
                this.education = resp.data;
              }

              resolve();
            } else {
              resolve();
            }
          })
          .catch(() => {
            // console.log(error);
            const notification = {
              type: "danger",
              message: "Er is een fout opgetreden.",
                error: true
            };
            this.$store.dispatch("notification/replace", notification, {
              root: true
            });
            reject();
          });
      });
    },
    // get questions
    async getQuestions() {
      let promises = [];
      var q_url = this.$apiURI + "/question/education/";

      // assign questions
      for (var obj in this.education) {
        promises.push(
          new Promise(resolve => {
            // console.log(obj);
            // console.log(q_url + obj);
            // resolve();
            // for (var arr in this.guide[obj]) {
            this.$http({
              method: "GET",
              url: q_url + obj
            }).then(
              result => {
                var q_id = result.data.data[0].id;
                var q_number = result.data.data[0].number;
                this.$set(this.questions, q_number, {
                  id: q_id,
                  display: result.data.data[0].display
                });
                resolve();
              },
              error => {
                console.error(error);
              }
            );
            // }
          })
        );
      }
      return Promise.all(promises);
    },
    getWorkfieldByNumber(workfieldNumber) {
      switch (workfieldNumber) {
        case 0:
          return "Dagopvang & BSO";
        case 1:
          return "Dagopvang";
        case 2:
          return "BSO";
        case 3:
          return "-";
        case 4:
        case 5:
        case 6:
        case 7:
          return "Onbekend (In afwachting van diploma's)";
        default:
          return null;
      }
    },
    translate(answer) {
      if (answer == "NO") {
        return "Nee";
      }
      if (answer == "YES") {
        return "Ja";
      }
      if (answer == "STUDYING") {
        return "Studerend";
      }
      return answer;
    },
    async sortQs() {
      let promises = [];
      promises.push(
        new Promise(resolve => {
          var list = this.questions;
          // console.log("list: ");
          // console.log(list);
          const keysSorted = Object.keys(list).sort(function(a, b) {
            return list[a] - list[b];
          });
          this.questions_array = keysSorted;
          this.questions_array = list;
          // console.log(keysSorted);
          // console.log(this.questions_array);
          resolve();
        })
      );
      return Promise.all(promises);
    }
  }
};
</script>

<style scoped>
.btn-gray {
  margin: 20px 0 0;
}
.range-values div {
  position: relative;
  margin-top: -2px;
}
.range-values .float-left {
  left: -3px;
}
.range-values .float-right {
  right: -8px;
}

#collapseEducation ul li {
  margin-bottom: 5px;
}
section.block.border-bottom ul label.float-left.educ {
  height: 15px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow-y: visible;
  overflow: hidden;
}
section.block.border-bottom ul .float-left.val.educ {
  height: 25px;
}
#collapseEducation ul li > div:not(:first-child) .val {
  position: relative;
  height: auto;
  line-height: 100%;
  padding: 3px 0;
}

section.block.border-bottom button[data-toggle="collapse"] {
  font-size: 17px;
  font-family: "Real Head Pro";
  font-weight: normal;
  border: none;
  background: none;
  padding: 0;
  color: #625a55;
  outline: none;
  width: 100%;
  position: relative;
  top: 4px;
}
section.block.border-bottom button[data-toggle="collapse"] i {
  color: #FFCD00;
  font-size: 26px;
  position: relative;
  top: -4px;
}
section.block.border-bottom button[aria-expanded] span.float-right {
  position: relative;
  display: none;
  right: -11px;
  top: 4px;
  width: 30px;
  height: 18px;
}
section.block.border-bottom button[aria-expanded="false"] span.right {
  display: block;
}
section.block.border-bottom button[aria-expanded="true"] span.down {
  display: block;
}
#app section.block.border-bottom .collapse label.educ {
    overflow:visible;
    white-space:normal;
    text-overflow:unset;
    height: inherit;
    top:0;
    line-height:normal;
}
#app section.block.border-bottom .collapse .clearfix.text-14{
    display:flex;
    height:auto;
    line-height: normal;
    min-height: 20px;
    padding: 3px 0;
}
#app section.block.border-bottom .collapse .clearfix.text-14 > *{
    float:none !important;
    flex: 50%;
}
#app section.block.border-bottom .collapse .clearfix.text-14 > *:last-child{
    height: inherit;
    position: relative;
    align-self: flex-end;
}
#app section.block.border-bottom .collapse .clearfix.text-14 > *:last-child > *{
    display:inline-block;
    line-height: normal;
}
@media screen and (max-width: 375px){
    section.block.border-bottom button{
        width:calc(100% + 5px) !important;
    }
}

</style>
